import BossModel from "@/models/BossModel";
import PriceExtension from "@/models/Product/PriceExtension/PriceExtension";

export default class Element extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'product/price-extension/element';

    /**
     *
     * @type {string}
     */
    static entity = 'productPriceExtensionElement';

    static fields() {
        return {
            id: this.number(null).nullable(),
            product_price_extension_id: this.number(null),
            product_id: this.number(null),
            finished_at: this.attr(),
            priceExtension: this.belongsTo(PriceExtension, 'product_price_extension_id'),
        }
    }
}
